export const TEMP_PMP_IMG = 'https://placehold.co/'
